export const attackTypes = [
  '6+',
  '5+',
  '4+',
  '3+',
  '2+',
];

export const attackConversionValues = new Map<string, number>([
  [attackTypes[0], 6],
  [attackTypes[1], 5],
  [attackTypes[2], 4],
  [attackTypes[3], 3],
  [attackTypes[4], 2],
]);

export const attackValues = new Map<string, [number, number]>([
  [attackTypes[0], [6, 6]],
  [attackTypes[1], [6, 5]],
  [attackTypes[2], [5, 6]],
  [attackTypes[3], [5, 5]],
  [attackTypes[4], [5, 4]],
  [attackTypes[5], [4, 5]],
  [attackTypes[6], [4, 4]],
  [attackTypes[7], [4, 3]],
  [attackTypes[8], [3, 4]],
  [attackTypes[9], [3, 3]],
  [attackTypes[10], [3, 2]],
  [attackTypes[11], [2, 3]],
  [attackTypes[12], [2, 2]],
]);

export const saveTypes = [
  '6+',
  '5+',
  '4+',
  '3+',
  '2+',
];

export const wardTypes = [
  'None',
  '6+',
  '5+',
  '4+',
];

export const critTypes = [
  'None',
  'Crit (Mortal)',
  'Crit (Auto-wound)',
  'Crit (2 Hits)',
];

export const saveValues = new Map<string, number>([
  ['None', 7],
  [saveTypes[0], 6],
  [saveTypes[1], 5],
  [saveTypes[2], 4],
  [saveTypes[3], 3],
  [saveTypes[4], 2],
]);